(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-menu/assets/javascripts/competition-menu-context.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-menu/assets/javascripts/competition-menu-context.js');
"use strict";


const _React = React,
  createContext = _React.createContext;
const CompetitionMenuContext = createContext();
setGlobal('svs.components.marketplaceCompetition.competitionMenu.CompetitionMenuContext', CompetitionMenuContext);

 })(window);